import { render, staticRenderFns } from "./EmployerLetterPage.vue?vue&type=template&id=de3849b6&"
import script from "./EmployerLetterPage.vue?vue&type=script&lang=ts&"
export * from "./EmployerLetterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de3849b6')) {
      api.createRecord('de3849b6', component.options)
    } else {
      api.reload('de3849b6', component.options)
    }
    module.hot.accept("./EmployerLetterPage.vue?vue&type=template&id=de3849b6&", function () {
      api.rerender('de3849b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Letter/EmployerLetterPage.vue"
export default component.exports